import {FC} from 'react'
import {KTSVG, WithChildren} from '../../../helpers'
import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";

type LogoutProps = {
  title: string
  icon?: string
}

const LogoutMenuItem: FC<LogoutProps & WithChildren> = ({title, icon}) => {
  const navigate = useNavigate();

  const logOut = async (event: React.MouseEvent) => {
    event.preventDefault();
    try {
      const auth = getAuth();
      await signOut(auth);
      localStorage.clear()
      navigate('/login');
    } catch (error: any) {
      console.error('Logout failed: ', error.message);
    }
  };

  return (
    <div className='menu-item'>
      <div onClick={logOut} className='menu-link'>
        {icon && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        <span className='menu-title'>{title}</span>
      </div>
    </div>
  )
}

export {LogoutMenuItem}